import { PrivateContentProvider } from './components/PrivateContentProvider';
import { MemoryViewerClose } from './components/MemoryViewerClose';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { BirthdayAudioProvider } from './hooks/useBirthdayAudio';
import './styles/index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BirthdayAudioProvider>
      <>
        <PrivateContentProvider><App /></PrivateContentProvider>
        <MemoryViewerClose />
      </>
    </BirthdayAudioProvider>
  </StrictMode>,
);
